import { NgSelectComponent } from '@ng-select/ng-select';
import { SelectDrawerComponent } from '../../../../../../core/select-drawer/select-drawer.component';
import { Component, Input, EventEmitter, OnInit, Output, ViewChild, ChangeDetectorRef, ElementRef, OnDestroy } from '@angular/core';
import { FormArray, FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { Field, FieldType, PossibleFieldValue } from '../../../../../../service-groups/articles/article-details/field/field.model';
import { Subscription } from 'rxjs';
import { BaseSelectItem } from '../../../../../../core/select-drawer/base-select-item.interface';
import { UtilsService } from '../../../../../../core/utils/utils.service';
import { debounceTime } from 'rxjs/operators';
import moment from 'moment/moment';
// import { NgxTimepickerFieldComponent } from 'ngx-material-timepicker';
import { CalculatorKeyboardComponent } from '../../../../../../core/calculator-keyboard/calculator-keyboard.component';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Product } from '../../../../../../products/product.model';
import { NotificationService } from 'src/app/core/notification/notification.service';
import { SettingsService } from '../../../../../../settings/settings.service';
import { Attachment } from '../../../../../../core/attachment/attachment.model';
import { evaluate } from 'mathjs';
import { Job } from '../../../job.model';
import { TranslateService } from '@ngx-translate/core';
import { TextTmpl } from '../../../../../../text-templates/text-tmpl.model';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { IonInput, IonModal, IonTextarea, Platform } from '@ionic/angular';
import { NgxMatTimepickerFieldComponent } from 'ngx-mat-timepicker';
import { StorageService } from '../../../../../../core/storage/storage.service';
import { environment } from '../../../../../../../environments/environment';
import Swal from 'sweetalert2';
import { Browser } from '@capacitor/browser';
import { LoggerService } from '../../../../../../core/logger/logger.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../../../../../auth/auth.service';
import { JobLinkingsComponent } from '../../job-linkings/job-linkings.component';
import { DbService } from '../../../../../../core/db/db.service';

@Component({
    selector: 'app-job-article-field',
    templateUrl: './job-article-field.component.html',
    styleUrls: ['./job-article-field.component.scss'],
})
export class JobArticleFieldComponent implements OnInit, OnDestroy {
    // We use our drawer a bit differently here cause normally when using this component it is accompanied by a lot of other field components as well and in most instances those are select fields as well which results in rendering a lot of drawer components. This poses no real problem on strong hardware but weak mobile devices struggle really hard. Therefore we "manually" render the drawer component when needed and let it toggle as soon as it is rendered. This is done by the below property which activates the ngif which in turn updates the ViewChild selector below that then toggles the drawer. By reacting to the openStateChanged we can reset the below prop to false again which removes the component again
    renderDrawerComponent = false;
    platformIOS: boolean = this.platform.is('ios');
    private _drawerInstance;

    @ViewChild('selectDrawer', { static: false }) set selectDrawer(val: SelectDrawerComponent) {
        this._drawerInstance = val;

        if (this._drawerInstance && !this._drawerInstance.isOpen) {
            setTimeout((_) => {
                this._drawerInstance.toggleDrawer();
            }, 250);
        }
    }

    get selectDrawer(): SelectDrawerComponent {
        return this._drawerInstance;
    }

    // not both drawers can be active at the same time so we save the component in the same variable
    @ViewChild('userSelectDrawer', { static: false }) set userSelectDrawer(val: SelectDrawerComponent) {
        this._drawerInstance = val;

        if (this._drawerInstance && !this._drawerInstance.isOpen) {
            setTimeout((_) => {
                this._drawerInstance.toggleDrawer();
            }, 250);
        }
    }

    @ViewChild('calculatorMobileKeyboard') calculatorMobileKeyboard: CalculatorKeyboardComponent;

    @ViewChild('timepickertogglebtn', { read: ElementRef, static: false }) tpbtn: ElementRef;
    @ViewChild('timePickerField') timePickerField: NgxMatTimepickerFieldComponent;
    @ViewChild('datePicker') datePicker: MatDatepicker<moment.Moment>;
    @ViewChild('ngSelectDropdown', { static: false }) ngSelectDropdown: NgSelectComponent;
    @ViewChild('tinyMceEditor', { static: false }) tinyMceEditor: EditorComponent;
    @ViewChild('templateModal') templateModal: IonModal;
    @ViewChild('calculatorPreviewInput') calculatorPreviewInput: IonTextarea;
    @ViewChild('jobLinkingsComp') jobLinkingsComp: JobLinkingsComponent;
    @Input() projectId: string;
    @Input() jobId: string;
    @Input() fieldFormGroup: FormGroup;
    @Input() changesAllowed = false;
    @Input() publicView = false;
    @Input() linkFieldRelation: string;
    @Input() asDialog = false;
    @Output() articleFieldFormGroupChanged = new EventEmitter<any>();
    @Output() duplicateGroup = new EventEmitter<string>();
    @Output() deleteDuplicatedGroup = new EventEmitter<string>();
    @Output() lockRequested = new EventEmitter<string>();
    @Output() jobSaveRequested = new EventEmitter();
    @Output() removedJobLinkId = new EventEmitter<string>();
    @Output() addedJobLinkId = new EventEmitter<string>();

    openTimepicker() {
        if (this.changesAllowed) {
            this.tpbtn.nativeElement.click();
        }
    }

    subFieldVisibilityMapping = []; // used to calculate if a sub field is visible or not

    // text editor
    textEditorInitialized = false;
    textEditorToolBar = [
        { name: 'history', items: ['undo', 'redo'] },
        { name: 'custom', items: ['text-templates'] },
        { name: 'formatting', items: ['bold', 'italic', 'underline', 'strikethrough'] },
        { name: 'lists', items: ['blockquote', 'numlist', 'bullist'] },
        { name: 'styles', items: ['styles'] },
        { name: 'color_link', items: ['link', 'forecolor', 'backcolor'] },
        { name: 'alignment', items: ['alignleft', 'aligncenter', 'alignright', 'alignjustify'] },
        { name: 'format', items: ['removeformat'] },
    ];
    styleFormatsToolBar = [];
    editorInit: EditorComponent['init'] = null;
    editorLang = this.translate.currentLang;
    editorLangUrl = `/assets/tinymce-langs/${this.translate.currentLang}.js`;

    // products
    productModalVisible = false;
    currentMultiProductSelectionProducts: Array<Product> = [];

    // templates
    currentMultiSelectionTemplates: Array<TextTmpl> = [];

    // helper
    possibleFieldTypes = FieldType;
    formChangeSubscription: Subscription;
    codeFieldScanModalVisible = false;
    mobileViewActive = false;
    mobileDrawerItems: Array<BaseSelectItem> = [];
    mobileDrawerValue = undefined;
    fieldValueFormControl: FormControl; // helper form control which holds the temporary field value
    fieldValueChangeSubscription: Subscription;
    datePickerInputData = null;

    userFieldPossibleUsers = [];
    userFieldCurrentSelectedUsers;

    calculatorCurrentResult: string | false = null;
    maxAllowedNumber = Number.MAX_SAFE_INTEGER;

    private _lastSelectedVal;
    private _allowedChars = /^-?[\d.,]*$/; // Allows optional minus, digits, period, comma

    get fieldValue() {
        return this.fieldValueFormControl.value;
    }

    set fieldValue(val) {
        this.fieldValueFormControl.setValue(val);
    }

    get isSelect() {
        return [FieldType.Select, FieldType.ExtendableSelect].includes(this.fieldFormGroup.get('type').value);
    }

    get isUser() {
        return this.fieldFormGroup.get('type').value === FieldType.User;
    }

    get isLinking() {
        return this.fieldFormGroup.get('type').value === FieldType.Linking;
    }

    get isExtendable() {
        return this.fieldFormGroup.get('type').value == FieldType.ExtendableSelect;
    }

    get isCheckbox() {
        return this.fieldFormGroup.get('type').value == FieldType.Checkbox;
    }

    get isDate() {
        return this.fieldFormGroup.get('type').value == this.possibleFieldTypes.Date;
    }

    get isTextEditor() {
        return this.fieldFormGroup.get('type').value == this.possibleFieldTypes.TextEditor;
    }

    get isGroup() {
        return this.fieldFormGroup.get('type').value == this.possibleFieldTypes.Group;
    }

    get isEmpty() {
        if (this.fieldValue != '' && this.fieldValue != undefined) {
            return false;
        }
        return true;
    }

    get fieldFormGroupPossibleValueControls() {
        return (this.fieldFormGroup.get('possibleValues') as FormGroup | FormArray).controls;
    }

    constructor(
        public utils: UtilsService,
        private notifySrv: NotificationService,
        private cdRef: ChangeDetectorRef,
        public settingsSrv: SettingsService,
        private storage: StorageService,
        private translate: TranslateService,
        private logger: LoggerService,
        private platform: Platform,
        private http: HttpClient,
        protected authSrv: AuthService,
        private db: DbService
    ) {}

    ngOnInit() {
        this.formChangeSubscription = this.fieldFormGroup.valueChanges.pipe(debounceTime(500)).subscribe((val) => {
            this.articleFieldFormGroupChanged.emit(val);
            this.calculateSubFieldVisibility();
            if (this.fieldFormGroup.get('autoFillLastValue').value === true) {
                this.updateAutoFillValue();
            }
        });
        this.mobileViewActive = this.utils.mobileViewActive;

        // init our field value form control - because we need to transform the input formarray to an form control so ng select handles it correctly
        // as soon as our temporary field value form control changes, we updated the original field formGroup too
        // But we need to make sure that we don't have null elements inside Arrays as this breaks ngSelect on saving data
        let tmpVal = this.fieldFormGroup.get('value').value;
        if (Array.isArray(tmpVal)) {
            tmpVal = tmpVal.filter((v) => v != null);
        }
        this.fieldValueFormControl = new FormControl(tmpVal);
        this.fieldValueChangeSubscription = this.fieldValueFormControl.valueChanges.subscribe((val) => {
            if (Array.isArray(val)) {
                val = val.filter((v) => v !== '' && v !== 'ng-add-custom-value');
            }
            if (val === '') {
                if (!this.isTextEditor) {
                    return;
                }
            }

            // Prevent input of non numbers
            if (this.fieldFormGroup.get('type').value === FieldType.Number) {
                if (!/^-?d+([.,]d+)?$/.test(val)) {
                    console.warn('Invalid number input. resetting', val);
                    this.fieldValue = undefined;
                    this.fieldFormGroup.get('value').setValue(undefined, { emitEvent: false });
                    return;
                }
            }

            if (Array.isArray(this.fieldFormGroup.get('value').value)) {
                // clear the field form group value first by clearing the array if it is an form array, or setting an empty array value
                if (this.fieldFormGroup.get('value') instanceof FormArray) {
                    (<FormArray>this.fieldFormGroup.get('value')).clear();
                    if (Array.isArray(val)) {
                        // push the values to the form array
                        for (let entry of val) {
                            (<FormArray>this.fieldFormGroup.get('value')).push(new FormControl(entry));
                        }
                    } else {
                        (<FormArray>this.fieldFormGroup.get('value')).push(new FormControl(val));
                    }
                } else {
                    let newValArray = [];
                    if (Array.isArray(val)) {
                        for (let entry of val) {
                            newValArray.push(entry);
                        }
                    } else {
                        newValArray.push(val);
                    }
                    this.fieldFormGroup.get('value').setValue(newValArray);
                }
            } else {
                if (this.isUser && val == null) {
                    // if user-field and the value we want to set is null we have to remove all sub-controls of the value field first to reset the field (if there was a user selected before, the form control cannot be saved because it has sub-properties set and setValue cannot handle that)
                    if ((<FormGroup>this.fieldFormGroup.get('value'))?.controls?.userName != null) {
                        this.fieldFormGroup.removeControl('value');
                        this.fieldFormGroup.addControl('value', new UntypedFormControl(null));
                    }
                    this.fieldFormGroup.get('value').setValue(val);
                } else if (this.isTextEditor && (val == '<p></p>' || val === '')) {
                    // if the text editor content gets removed, sometimes a single <p> tag is left which will not get deleted, so set field value manually
                    this.fieldFormGroup.get('value').setValue(null);
                } else {
                    // default handling
                    this.fieldFormGroup.get('value').setValue(val);
                }
            }

            // if we have just adjusted an select field we should extend the possibleValues
            if (this.isSelect && this.isExtendable) {
                // check which values are not in the possibleValues list
                if (val === 'ng-add-custom-value' || val == null) {
                    return; // skip temporary values
                }
                let valuesToAdd = [];
                if (Array.isArray(val)) {
                    for (let entry of val) {
                        let found = this.fieldFormGroup.get('possibleValues').value.find((x) => x.value == entry);
                        if (found == null) {
                            valuesToAdd.push(entry);
                        }
                    }
                } else {
                    let found = this.fieldFormGroup.get('possibleValues').value.find((x) => x.value == val);
                    if (found == null) {
                        valuesToAdd.push(val);
                    }
                }
                for (let val of valuesToAdd) {
                    (<FormArray>this.fieldFormGroup.get('possibleValues')).push(
                        this.utils.objectToFormGroup(
                            new PossibleFieldValue({
                                value: val,
                            })
                        )
                    );
                }
            }
        });

        if (this.isTextEditor) {
            // this.textEditor = new Editor(); // init
            if (!this.changesAllowed) {
                this.fieldValueFormControl.disable(); //cannot be done via attribute binding in html, library only supports disabling this way
            }

            switch (this.translate.currentLang) {
                case 'bs':
                    // special language handling - tinymce has no translation for bosnian so fallback to english
                    this.editorLang = 'en';
                    this.editorLangUrl = `/assets/tinymce-langs/en.js`;
                    break;
                default:
                    this.editorLang = this.translate.currentLang;
                    this.editorLangUrl = `/assets/tinymce-langs/${this.translate.currentLang}.js`;
                    break;
            }

            this.styleFormatsToolBar = [
                {
                    title: this.translate.instant('projects.jobs.details.article.te-style-formats.h1'),
                    block: 'h1',
                },
                {
                    title: this.translate.instant('projects.jobs.details.article.te-style-formats.h2'),
                    block: 'h2',
                },
                {
                    title: this.translate.instant('projects.jobs.details.article.te-style-formats.h3'),
                    block: 'h3',
                },
                {
                    title: this.translate.instant('projects.jobs.details.article.te-style-formats.h4'),
                    block: 'h4',
                },
                {
                    title: this.translate.instant('projects.jobs.details.article.te-style-formats.p'),
                    block: 'p',
                },
            ];

            // remove text-templates for public-view due it's not supported yet
            if (this.publicView) {
                let textTemplatesIndex = this.textEditorToolBar.findIndex((x) => x.name === 'custom');
                if (textTemplatesIndex > -1) {
                    this.textEditorToolBar.splice(textTemplatesIndex, 1);
                }
            }

            this.editorInit = {
                base_url: '/tinymce',
                suffix: '.min',
                plugins: 'lists link image table code wordcount autoresize',
                content_style: 'body { font-family: Quicksand,sans-serif; font-weight: 400; }',
                font_css: '/assets/fonts/fonts.min.css',
                paste_data_images: false,
                toolbar: this.changesAllowed ? this.textEditorToolBar : false,
                toolbar_mode: 'wrap',
                setup: (editor: any) => {
                    editor.ui.registry.addButton('text-templates', {
                        icon: 'paste-text',
                        tooltip: this.translate.instant('projects.jobs.details.article.te-style-formats.t-templates'),
                        onAction: () => {
                            this.templateModal.present(); // open modal
                        },
                    });
                },
                indent: false,
                style_formats: this.styleFormatsToolBar,
                height: 150,
                min_height: 150,
                max_height: undefined,
                placeholder: this.translate.instant('projects.jobs.details.article.fill-value-placeholder'),
                contextmenu: false,
                menubar: false,
                branding: false,
                elementpath: false,
                language: this.editorLang,
                language_url: this.editorLangUrl,
            };
            this.textEditorInitialized = true;
        }

        // while using date data we need to transoform our millisec timestamps to actual objects for the picker
        if (this.isDate && this.fieldValueFormControl.value != null) {
            this.datePickerInputData = moment(this.fieldValueFormControl.value);
        }

        this.subFieldVisibilityMapping = [];
        this.calculateSubFieldVisibility();

        // trigger first init math calculation for existing field value
        if (this.fieldFormGroup.get('type').value === FieldType.Calculator) {
            this.onCalculatorFieldChanged(this.fieldFormGroup.get('value').value, false);
        }

        // init available user list and current user field selection
        if (this.isUser) {
            this.userFieldCurrentSelectedUsers = Array.isArray(this.fieldValue)
                ? this.fieldValue.map((x) => x.userName)
                : this.fieldValue?.userName;
            let okLicenseTypes = this.fieldFormGroup.get('userFieldAllowedLicenseTypes').value || [];
            this.userFieldPossibleUsers = this.settingsSrv.latestAuthInfo.companyUsers
                .filter((x) => okLicenseTypes.length === 0 || okLicenseTypes.includes(x.licenseType))
                .map((x) => {
                    return {
                        userName: x.userName,
                        email: x.email,
                        firstName: x.firstName,
                        lastName: x.lastName,
                    };
                });
        }

        this.currentMultiProductSelectionProducts = [];
        this.currentMultiSelectionTemplates = [];
    }

    ngOnDestroy() {
        if (this.formChangeSubscription) {
            this.formChangeSubscription.unsubscribe();
        }
        if (this.fieldValueChangeSubscription) {
            this.fieldValueChangeSubscription.unsubscribe();
        }
    }

    /**
     * Triggered when the field uses the autofill function to automatically fill the last used value. If autofill is activated we save the input value for further usage
     */
    async updateAutoFillValue() {
        let lastAutoFillFields = await this.storage.get('dp_autofill_fields');
        if (!Array.isArray(lastAutoFillFields)) {
            lastAutoFillFields = [];
        }

        // save auto fill value if auto-fill setting is true
        let existingAutoFillField = lastAutoFillFields.find((x) => x.fieldName === this.fieldFormGroup.get('name').value);
        if (existingAutoFillField != null) {
            existingAutoFillField.fieldValue = this.fieldFormGroup.get('value').value;
            existingAutoFillField.timestamp = Date.now();
        } else {
            lastAutoFillFields.push({
                fieldName: this.fieldFormGroup.get('name').value,
                fieldValue: this.fieldFormGroup.get('value').value,
                timestamp: Date.now(),
            });
        }
        await this.storage.set('dp_autofill_fields', lastAutoFillFields);
    }

    onScanFieldCodeResult(scanResult: string) {
        this.fieldValue = scanResult;

        this.codeFieldScanModalVisible = false;

        setTimeout((_) => {
            this.cdRef.detectChanges();
        }, 200);
    }

    /**
     * Helper function to prepare FormGroup data as base items for the drawer
     * @returns
     */
    getItemsFromFormGroup(): Array<BaseSelectItem> {
        if (this.isUser) {
            return this.userFieldPossibleUsers.map((item) => {
                return {
                    _id: item.userName,
                    name: item.firstName + ' ' + item.lastName,
                    type: 'user',
                } as BaseSelectItem;
            });
        } else {
            return this.fieldFormGroup.value.possibleValues.map((item, index) => {
                return {
                    _id: index.toString(),
                    name: item.value,
                    icon: item.icon,
                    iconColor: item.color,
                    type: 'job-field',
                } as BaseSelectItem;
            });
        }
    }

    // Helper function to check if a value is in our form field
    formFieldIncludesValue(value) {
        if (this.isUser) {
            if (Array.isArray(this.fieldValue)) {
                return this.fieldValue?.includes(value);
            } else {
                return this.fieldValue === value;
            }
        } else {
            // Just using indexOf or includes would leave possibilites as showing values 1 and 10 in the UI while only the single value 10 was selected - due to both including the number 1
            if (Array.isArray(this.fieldValue)) {
                return this.fieldValue?.includes(value);
            } else {
                return this.fieldValue === value;
            }
        }
    }

    onMobileSelectItemChanged(selectedValue) {
        if (this.isUser) {
            if (Array.isArray(selectedValue)) {
                let foundUsers = [];
                for (let val of selectedValue) {
                    let found = this.userFieldPossibleUsers.filter((x) => x.userName === val._id);
                    foundUsers = [...foundUsers, ...found];
                }
                this.fieldValue = foundUsers;
            } else {
                if (selectedValue == null) {
                    this.fieldValue = selectedValue;
                } else {
                    this.fieldValue = this.userFieldPossibleUsers.find((x) => x.userName === selectedValue._id);
                }
            }
        } else {
            if (Array.isArray(selectedValue)) {
                this.fieldValue = selectedValue.map((i) => i.name);
            } else {
                this.fieldValue = selectedValue ? selectedValue.name : selectedValue;
            }
        }
    }

    drawerOpenStateChanged(open: boolean) {
        // Important for resetting render state after selection to unload component data
        if (open != this.renderDrawerComponent) {
            this.renderDrawerComponent = open;
        }
    }

    maybeToggleUiControl() {
        if (this.isSelect || this.isUser) {
            // if (!(this.utils.isPhone || this.utils.isTablet) && this.ngSelectDropdown && !this.ngSelectDropdown.isOpen && this.changesAllowed) {
            //     this.ngSelectDropdown.open();
            // } else {
            // }
            this.maybeToggleDrawer();
        } else if (this.isDate) {
            this.maybeToggleDatePicker();
        }
    }

    maybeToggleDrawer() {
        if ((this.isSelect || this.isUser) && this.changesAllowed) {
            this.mobileDrawerItems = this.getItemsFromFormGroup();

            // get current field value and pre-select it in the drawer
            if (this.isUser) {
                if (Array.isArray(this.fieldValue)) {
                    let valArr = [];
                    for (let user of this.fieldValue) {
                        let selected = this.mobileDrawerItems.find((x) => x._id === user.userName);
                        if (selected != null) {
                            valArr.push(selected);
                        }
                    }
                    this.mobileDrawerValue = valArr;
                } else {
                    this.mobileDrawerValue = this.mobileDrawerItems.find((i) => i._id === this.fieldValue?.userName) || undefined;
                }
            } else {
                if (Array.isArray(this.fieldValue)) {
                    this.mobileDrawerValue = this.mobileDrawerItems.filter((i) => this.fieldValue.includes(i.name)) || [];
                } else {
                    this.mobileDrawerValue = this.mobileDrawerItems.find((i) => i.name === this.fieldValue) || undefined;
                }
            }

            // open or render and then open the drawer
            if (this.selectDrawer) {
                this.selectDrawer.toggleDrawer();
            } else {
                // "Toggle" our drawer indirectly for first time render
                this.renderDrawerComponent = true;
            }
        }
    }

    maybeToggleDatePicker() {
        if (this.changesAllowed) {
            this.datePicker.open();
        }
    }

    toggleScan(event) {
        event.stopPropagation();
        event.preventDefault();

        this.codeFieldScanModalVisible = !this.codeFieldScanModalVisible;
    }

    // Used to keep the last selected value if users would swap around with extendable selects
    async onNgSelectOpen(vent) {
        this._lastSelectedVal = this.fieldValue;
    }

    async onNgSelectChange(selectedVal: string | Array<string>) {
        if (Array.isArray(selectedVal)) {
            let addCustomItemIndex = selectedVal.indexOf('ng-add-custom-value');
            if (addCustomItemIndex != -1) {
                selectedVal.splice(addCustomItemIndex, 1);

                await this.handleCustomSelectValAddition(selectedVal, true);
            }
        } else if (selectedVal === 'ng-add-custom-value') {
            await this.handleCustomSelectValAddition(selectedVal, false);
        }
    }

    async handleCustomSelectValAddition(val: string | Array<string>, multi: boolean) {
        try {
            let newVal = (await this.notifySrv.prompt(
                undefined,
                this.translate.instant('projects.jobs.details.article.custom-val-title'),
                undefined,
                this.translate.instant('projects.jobs.details.article.custom-val-placeholder')
            )) as string;

            // prepare the input data to keep out whitespace
            if (!newVal) {
                newVal = '';
            } else {
                newVal = newVal.trim();
            }

            if (multi && this.fieldValue.indexOf(newVal) == -1) {
                if (newVal !== '') {
                    (val as Array<string>).push(newVal);
                }
                this.fieldValue = val;
            } else if (!multi && newVal != this.fieldValue) {
                if (newVal === '') {
                    this.fieldValue = this._lastSelectedVal;
                } else {
                    this.fieldValue = newVal;
                }
            } else {
                // Got a situation where we can't update the fieldValue due to already set to same value or other reasons
                // e.g. adding the same custom value twice - so we need to remove the custom value placeholder
                this.fieldValue = val;
            }
        } catch (nameEx) {
            // did cancel
            if (this._lastSelectedVal) {
                this.fieldValue = this._lastSelectedVal;
            } else {
                this.fieldValue = undefined;
            }
        }
    }

    /**
     * Triggered when the user field changes on desktop (ng-select library)
     * @param data
     */
    onUserFieldNgSelectChanged(data) {
        if (Array.isArray(data)) {
            if (data.length === 0) {
                this.fieldValue = [];
            } else {
                this.fieldValue = this.userFieldPossibleUsers.filter((x) => data.includes(x.userName));
            }
        } else {
            this.fieldValue = this.userFieldPossibleUsers.find((x) => x.userName === data);
        }
    }

    onTimePickerFieldChanged(time: string) {
        this.fieldFormGroup.get('value').setValue(time);
    }

    resetTimePickerVal(event) {
        event.preventDefault();
        event.stopPropagation();

        // reset our form element
        this.fieldFormGroup.get('value').setValue(undefined);
        // resets the data behind the input field and the clock selector
        this.timePickerField.timepickerTime = undefined;
        // resets the input field but only when above is done before
        this.timePickerField.writeValue(undefined);
    }

    onTimePickerChanged(time: string) {
        this.onTimePickerFieldChanged(time);

        // Manually update the picker field as bindings via formControl dont work
        // and our custom UI layout does not allow the included toggle component
        if (time && this.timePickerField) {
            this.timePickerField.onTimeSet(time);
        }
    }

    onDateItemClicked() {
        if (this.changesAllowed) {
            this.datePicker.open();
        }
    }

    resetDatePickerVal(event) {
        event.preventDefault();
        event.stopPropagation();

        this.datePickerInputData = undefined;
        this.fieldFormGroup.get('value').setValue(undefined);
        this.datePicker.select(undefined);
    }

    onDateChanged(data: MatDatepickerInputEvent<moment.Moment>) {
        // save our data as milliseconds
        let newDateData = data.value?.valueOf() || undefined;
        this.datePickerInputData = newDateData ? moment(newDateData) : newDateData;
        this.fieldFormGroup.get('value').setValue(newDateData);
    }

    onDatePickerMonthSelected(normalizedMonthAndYear: moment.Moment, datePicker) {
        if (this.fieldFormGroup.get('dateFieldFormat').value === 'month-year') {
            this.datePickerInputData = moment(normalizedMonthAndYear.valueOf());
            this.fieldFormGroup.get('value').setValue(normalizedMonthAndYear.valueOf());
            datePicker.close();
        }
    }

    onDatePickerYearSelected(normalizedYear: moment.Moment, datePicker) {
        if (this.fieldFormGroup.get('dateFieldFormat').value === 'only-year') {
            this.datePickerInputData = moment(normalizedYear.valueOf());
            this.fieldFormGroup.get('value').setValue(normalizedYear.valueOf());
            datePicker.close();
        }
    }

    /**
     * Triggered when the user wants to add a product to a field
     */
    onAddProductClicked() {
        if (!this.changesAllowed) {
            return;
        }
        this.productModalVisible = true;
    }

    /**
     * Triggered when the user has chosen a product to add to the product field
     */
    onProductChosen(products: Product[]) {
        if (this.fieldFormGroup.get('multiSelect').value === false) {
            // on single-select we automatically add selected product and close product-choose-modal, on multiselect the confirm button handles product-adding and we remember current selected products
            this.getSelectedProductsAsFormarray().push(this.utils.objectToFormGroup(new Product(products[0], true)));
            this.productModalVisible = false;
        } else {
            this.currentMultiProductSelectionProducts = products;
        }
    }

    /**
     * Triggered when multiple products were chosen and are now confirmed and added to the product-field
     */
    onMultipleProductsConfirmed() {
        // add all products which are selected to the product field and close dialog
        let existingProducts: Array<Product> = this.getSelectedProductsAsFormarray().value; // holds already selected products, we dont want to add the same product multiple times
        for (let product of this.currentMultiProductSelectionProducts) {
            if (existingProducts.find((x) => x._id === product._id) == null) {
                this.getSelectedProductsAsFormarray().push(this.utils.objectToFormGroup(new Product(product, true)));
            }
        }
        this.currentMultiProductSelectionProducts = []; // reset
        this.productModalVisible = false;
    }

    /**
     * Triggered when the user has chosen a template to add to the editor
     */
    onTextTemplateChosen(templates: TextTmpl[]) {
        if (this.fieldFormGroup.get('multiSelect').value === false) {
            this.tinyMceEditor?.editor?.insertContent(templates[0]?.text);
            this.templateModal?.dismiss();
        } else {
            this.currentMultiSelectionTemplates = templates;
        }
    }

    /**
     * Triggered when multiple templates were chosen and are now confirmed and added to the editor
     */
    onMultipleTextTemplatesConfirmed() {
        // currently not used --> add multiSelect option in service-groups to enable this feature for this type
        for (let template of this.currentMultiSelectionTemplates) {
            this.tinyMceEditor?.editor?.insertContent(template?.text);
        }

        this.currentMultiSelectionTemplates = []; // reset
        this.templateModal?.dismiss();
    }

    /**
     * Triggered when the user has removed a product from the product field
     * @param index
     */
    onProductRemoved(index: number) {
        this.getSelectedProductsAsFormarray().removeAt(index);
    }

    /**
     * Helper function which returns the selectedProducts property as formArray
     */
    getSelectedProductsAsFormarray() {
        return this.fieldFormGroup.get('selectedProducts') as FormArray;
    }

    /**
     * Adjusts number field in given direction
     * @param direction
     */
    stepNumberField(direction: 'up' | 'down') {
        let curVal = parseFloat(this.fieldFormGroup.get('value').value);
        if (isNaN(curVal)) {
            curVal = 0;
        }

        if (curVal === this.maxAllowedNumber && direction === 'up') {
            return;
        }

        if (direction === 'up') {
            curVal++;
        } else {
            curVal--;
        }
        this.fieldFormGroup.get('value').setValue(curVal);
    }

    /**
     * Function for checking status of checkbox
     * @param checkboxData the checkbox label data
     */
    isCheckBoxChecked(checkboxData) {
        let fieldFormGroupValue = this.fieldFormGroup.getRawValue();

        if (fieldFormGroupValue.multiSelect === true) {
            if (Array.isArray(fieldFormGroupValue.value)) {
                return fieldFormGroupValue.value.includes(checkboxData.value);
            } else {
                return fieldFormGroupValue.value === checkboxData.value;
            }
        } else {
            return fieldFormGroupValue.value === checkboxData.value;
        }
    }

    /**
     * Event triggered when user clicks on a checkbox
     * @param checked the property if user has checked the box or unchecked
     * @param clickedCheckbox the checkbox label data
     */
    onCheckboxClicked(checked, clickedCheckbox) {
        let fieldFormGroupValue = this.fieldFormGroup.getRawValue();
        let fieldValuesToUpdate = null;

        // check if field is multiSelect
        if (fieldFormGroupValue.multiSelect === true) {
            if (fieldFormGroupValue.value == null) {
                fieldValuesToUpdate = [clickedCheckbox.value];
            } else {
                if (Array.isArray(fieldFormGroupValue.value)) {
                    let temporaryFieldValues = fieldFormGroupValue.value;
                    let foundCheckboxValueInFieldFormGroupValuesIndex = temporaryFieldValues.findIndex((x) => x === clickedCheckbox.value);
                    if (foundCheckboxValueInFieldFormGroupValuesIndex > -1) {
                        temporaryFieldValues.splice(foundCheckboxValueInFieldFormGroupValuesIndex, 1);
                    } else {
                        temporaryFieldValues.push(clickedCheckbox.value);
                    }
                    fieldValuesToUpdate = temporaryFieldValues;
                } else {
                    if (!checked) {
                        fieldValuesToUpdate = [];
                    } else {
                        let temporaryFieldValues = [fieldFormGroupValue.value];
                        temporaryFieldValues.push(clickedCheckbox.value);
                        fieldValuesToUpdate = temporaryFieldValues;
                    }
                }
            }
        } else {
            if (fieldFormGroupValue.value == null) {
                fieldValuesToUpdate = clickedCheckbox.value;
            } else {
                fieldValuesToUpdate = checked ? clickedCheckbox.value : null;
            }
        }

        setTimeout(() => {
            this.fieldValue = fieldValuesToUpdate;
        }, 0);
    }

    onSignatureAdded(signature: Attachment) {
        let fieldFormGroupValue = this.fieldFormGroup.getRawValue();
        let fieldValuesToUpdate = null;
        if (fieldFormGroupValue.value != null) {
            if (Array.isArray(fieldFormGroupValue.value)) {
                fieldValuesToUpdate = fieldFormGroupValue.value;
            } else {
                fieldValuesToUpdate = [fieldFormGroupValue.value];
            }
        } else {
            fieldValuesToUpdate = [];
        }

        fieldValuesToUpdate.push(signature);

        this.fieldValue = fieldValuesToUpdate;
        console.log('SIGNATURES', this.fieldValue);
        const lockBehavior = this.fieldFormGroup.get('signatureLockBehavior')?.value;
        if (lockBehavior && lockBehavior !== 'none') {
            this.lockRequested.emit(lockBehavior);
        }
    }

    onSignatureDeleted(signatureIndex: number) {
        let signatures = this.getSignatures();
        signatures.splice(signatureIndex, 1);
        this.fieldValue = signatures;
    }

    getSignatures() {
        let signatures = [];
        if (this.fieldValue != null) {
            if (Array.isArray(this.fieldValue)) {
                signatures = this.fieldValue;
            } else {
                signatures = [this.fieldValue];
            }
        }
        return signatures;
    }

    /**
     * Triggered when the calculator field gets clicked on phones/tablets. Shows the calculator keyboard
     */
    async onCalculatorFieldClickedOnMobile() {
        if (this.changesAllowed && (this.utils.isPhone || this.utils.isTablet)) {
            let textarea = await this.calculatorPreviewInput?.getInputElement();
            textarea?.blur();
            await this.calculatorMobileKeyboard.show(this.fieldValue);
        }
    }

    /**
     * Triggered when the calculator input changes and the math result shall be calculated
     * @param input the calculation string (field value)
     * @param setFieldValue if true will override the current fieldValue of job field
     */
    onCalculatorFieldChanged(input, setFieldValue = true) {
        if (input == null || input == '') {
            this.calculatorCurrentResult = null;
            if (setFieldValue) {
                this.fieldValue = null;
            }
        } else {
            let inputVal = input.split(',').join('.');
            try {
                let calculatorResult = evaluate(inputVal);
                this.calculatorCurrentResult = parseFloat(calculatorResult).toFixed(2);
            } catch (evaluateErr) {
                this.calculatorCurrentResult = false;
            }
            if (setFieldValue) {
                this.fieldValue = inputVal;
            }
        }
    }

    // This function tries to detect interaction with a stylus and opens the keyboard accordingly
    // the touchType is a W3C working draft and only available in WebKit, so for all other styles detections this will do nothing
    async handleCalculatorTouchStart(event: TouchEvent) {
        if (!this.utils.isPhone && !this.utils.isTablet) return;

        if ((event.touches[0] as any).touchType === 'stylus') {
            await this.onCalculatorFieldClickedOnMobile();
        }
    }

    /**
     * Triggered when a job link gets added
     * @param data
     */
    async onAddJobLink(data: { linkType: 'existing' | 'new'; job: Job }) {
        //this.fieldValue = selectedValue;
        if (Array.isArray(this.fieldValue)) {
            this.fieldValue = [...this.fieldValue, data.job._id];
        } else {
            this.fieldValue = [data.job._id];
        }
        this.addedJobLinkId.emit(data.job._id);

        setTimeout(() => {
            this.jobSaveRequested.emit();

            if (data.linkType === 'new') {
                this.jobLinkingsComp?.onViewLinkedJob(data.job);
            }
        }, 1000);
    }

    /**
     * Triggered when the user removes a linkedJob
     * @param index
     */
    onRemoveJobLink(index: number, removedId: string) {
        if (Array.isArray(this.fieldValue)) {
            let newFieldValue = [...this.fieldValue];
            newFieldValue.splice(index, 1);
            this.fieldValue = newFieldValue;
            this.removedJobLinkId.emit(removedId);
        }
    }

    get dateFormatForField() {
        if (this.fieldFormGroup.get('dateFieldFormat').value === 'full-date') {
            return 'dd.MM.yyyy';
        } else if (this.fieldFormGroup.get('dateFieldFormat').value === 'month-year') {
            return 'MM/yyyy';
        } else {
            return 'yyyy';
        }
    }

    get startViewForDateField() {
        return this.fieldFormGroup.get('dateFieldFormat').value === 'full-date' ? 'month' : 'multi-year';
    }

    /**
     * Helper function wich returns the subfields for current field
     */
    getSubFieldsFormArray() {
        return this.fieldFormGroup.get('subFields') as FormArray;
    }

    /**
     * Calculates the subField visibility for our current field
     */
    calculateSubFieldVisibility() {
        if (this.isGroup) {
            for (let subFieldFormGroup of this.getSubFieldsFormArray().controls) {
                let fieldData = subFieldFormGroup.value as Field;
                this.subFieldVisibilityMapping[fieldData._id] = this.utils.checkFieldVisibilityCondition(
                    fieldData,
                    this.getSubFieldsFormArray().value
                );
                if (this.subFieldVisibilityMapping[fieldData._id] === false) {
                    // field is not visible, remove value if it is set, because we dont want invisible fields which have a value which could trigger other visibility conditions by mistake
                    this.utils.resetFieldValueOfFieldFormGroup(subFieldFormGroup);
                } else {
                    // field is visible, check if it is a select field where we could auto-fill if we only have one option to choose from
                    if (fieldData.type === FieldType.Select && fieldData.required && fieldData.possibleValues.length === 1) {
                        if (
                            fieldData.value == null ||
                            fieldData.value === '' ||
                            (Array.isArray(fieldData.value) && fieldData.value.length === 0)
                        ) {
                            // only set field.value if it currently is not set
                            if (fieldData.multiSelect) {
                                subFieldFormGroup.get('value').setValue([fieldData.possibleValues[0].value]);
                            } else {
                                subFieldFormGroup.get('value').setValue(fieldData.possibleValues[0].value);
                            }
                        }
                    }
                }
            }
        }
    }

    /**
     * Duplicate group in form array
     * @param fieldId the field id of the current form array element
     */
    onDuplicateGroupButton(fieldId: string) {
        this.duplicateGroup.emit(fieldId);
    }

    /**
     * Function to delete duplicate group from form array
     * @param fieldId the field id of the current form array element
     */
    onDeleteDuplicatedGroupButton(fieldId: string) {
        this.deleteDuplicatedGroup.emit(fieldId);
    }

    /**
     * Function to duplicate group field
     * @param idOfGroupField the id of the group field inside form array
     */
    onDuplicateGroup(idOfGroupField: string) {
        let foundArticleIndex = this.getSubFieldsFormArray().controls.findIndex((x) => x.get('_id').value === idOfGroupField);
        if (foundArticleIndex > -1) {
            // clone article data
            let foundArticleData = this.utils.clone(this.getSubFieldsFormArray().at(foundArticleIndex).value);
            let allDuplicatedFields = this.getSubFieldsFormArray().controls.filter((x) =>
                x.get('_id').value.startsWith(foundArticleData._id.split('|')[0])
            );

            // get last duplication Number
            let lastDuplicationNumber = allDuplicatedFields[allDuplicatedFields.length - 1].get('duplicationNumber').value;
            if (lastDuplicationNumber == null) {
                lastDuplicationNumber = 1;
            }

            foundArticleData.duplicationNumber = lastDuplicationNumber + 1;
            foundArticleData._id = `${foundArticleData._id.split('|')[0]}|${foundArticleData.duplicationNumber}`;
            foundArticleData.repetition = false;

            // create new form group and reset fields
            let foundArticle = this.utils.objectToFormGroup(foundArticleData);
            this.utils.resetFieldValueOfFieldFormGroup(foundArticle);

            // insert new article to form array
            let indexOfLastDuplicatedField = this.getSubFieldsFormArray().controls.findIndex(
                (x) => x.get('_id').value === allDuplicatedFields[allDuplicatedFields.length - 1].get('_id').value
            );
            if (indexOfLastDuplicatedField > -1) {
                this.getSubFieldsFormArray().insert(indexOfLastDuplicatedField + 1, foundArticle);
            } else {
                console.error('error while duplicate group. Index to push: ', indexOfLastDuplicatedField);
            }
        }
    }

    /**
     * Function to delete duplicated group field
     * @param idOfGroupField the id of the group field inside form array
     */
    onDeleteDuplicatedGroup(idOfGroupField: string) {
        let foundArticleIndex = this.getSubFieldsFormArray().controls.findIndex((x) => x.get('_id').value === idOfGroupField);
        if (foundArticleIndex > -1) {
            this.getSubFieldsFormArray().removeAt(foundArticleIndex);
        }
    }

    /**
     * Get duplication number of group field
     * @param duplicationNumber the duplication number of group field
     */
    getDuplicationNumber(duplicationNumber: number) {
        return duplicationNumber != null ? ' ' + duplicationNumber : '';
    }

    /**
     * Build name of repetition field
     */
    getNameOfRepetitionField() {
        let fieldValues = this.fieldFormGroup.value;
        let repetitionFieldName = this.translate.instant('shared.field-types.group');

        // check name
        if (fieldValues.name != null && fieldValues.name.trim() !== '') {
            repetitionFieldName = fieldValues.name;

            // get duplication number
            let duplicationNumber = this.getDuplicationNumber(fieldValues.duplicationNumber);
            repetitionFieldName += duplicationNumber;
        }

        return repetitionFieldName;
    }

    /**
     * Opens the saved link of a select field value in a new browser tab
     */
    async openSelectFieldLink(url: string, clickEvent: Event) {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();

        await this.openArticleLinkField(url, this.linkFieldRelation);
    }

    tooltipContentForProduct(metaFields) {
        let html = '';

        if (metaFields != null && metaFields?.length > 0) {
            for (let metaField of metaFields) {
                if (metaField.hideInReport === true && this.authSrv.isViewerLicense) {
                    continue;
                }
                html += `${metaField.name}: ${metaField.value}<br />`;
            }
        }

        return html;
    }

    /**
     * determines whether there are metaFields to display as tooltip or not
     * @param metaFields
     */
    hasVisibleMetaInfo(metaFields): boolean {
        if (metaFields == null || metaFields.length === 0) {
            return false;
        }
        if (!this.authSrv.isViewerLicense) {
            return true;
        }
        return metaFields.some((m) => !m.hideInReport);
    }

    /**
     * Validates and restricts input to only allowed characters for a numeric field.
     * Handles control keys, decimal separators, and minus signs appropriately.
     * Prevents the user from 90% of unwanted characters in the input
     *
     * @param {KeyboardEvent} event - The keyboard event triggered by user input.
     * @param {IonInput} inputEl - The IonInput element whose value is being validated.
     * @return {void} This method does not return any value.
     */
    validateNumberInputs(event: KeyboardEvent, inputEl: IonInput) {
        const input = event.key;
        //const currentValue = (event.target as HTMLInputElement).value; // this would work for generic input-fields
        const currentValue = inputEl.value && inputEl.value != '' ? inputEl.value.toString() : this.fieldValue?.toString();

        // Allow control keys (like Tab, Backspace, Delete, Arrow keys, Home, End, Ctrl+A, etc.)
        if (
            event.ctrlKey ||
            event.metaKey || // Ctrl or Cmd combinations
            input.length > 1 || // Allow pasting multiple characters (handled by ngModelChange)
            ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter', 'Escape'].includes(input)
        ) {
            return; // Let these pass through
        }

        // Check if the character is allowed by our simplified regex
        if (!this._allowedChars.test(input)) {
            event.preventDefault(); // Prevent the character from being entered
        }

        // Further logic require existing value to be meaningful
        if (!currentValue) {
            return;
        }

        // Additional logic to prevent multiple decimal separators or leading zeros issues if needed
        // For example, prevent entering another '.' or ',' if one already exists
        if ((input === '.' || input === ',') && (currentValue.includes('.') || currentValue.includes(','))) {
            event.preventDefault();
        }

        // Prevent multiple minus signs or minus sign not at the beginning
        if (input === '-') {
            if (currentValue.includes('-')) {
                event.preventDefault();
            }
        }
    }

    /**
     * Prevents input element to go above our max allowed number
     * @param event ionInput Event
     * @param inputEl the ion-input element itself
     */
    validateNumberInputChanges(event: any, inputEl: IonInput) {
        if (event.detail?.value > this.maxAllowedNumber) {
            inputEl.value = this.maxAllowedNumber;
        }

        this.fieldFormGroup.get('value').setValue(inputEl.value);
    }

    /**
     * Handles the link field
     * @param url the url to open
     * @param relation the relation of the field
     */
    async openArticleLinkField(url: string, relation: string) {
        // handle public-documents
        if (url?.startsWith('public-document#')) {
            try {
                let approvalDocumentRes = (await this.http
                    .get(
                        `${this.publicView ? environment.AWS_API_OIA_URL : environment.AWS_API_URL}/approval-document/${url.replace('public-document#', '')}?relation=${encodeURIComponent(relation)}`
                    )
                    .toPromise()) as any;

                if (approvalDocumentRes?.url == null) {
                    this.notifySrv.warn(this.translate.instant('settings.document-db.errors.no-version'));
                    return;
                }

                url = approvalDocumentRes?.url;

                if (approvalDocumentRes?.info?.zNumber != null && approvalDocumentRes?.info?.zNumber?.trim() !== '') {
                    let modalHtml = `<div class="approval-m-name">${approvalDocumentRes?.info?.commonName}</div>`;

                    modalHtml += '<table class="approval-m-table dp-mt-m" style="width: 100%;">';
                    modalHtml += `<tr><td>${this.translate.instant('settings.document-db.zNumber')}</td><td>${approvalDocumentRes?.info?.zNumber}</td></tr>`;

                    if (approvalDocumentRes?.version?.validFrom != null) {
                        modalHtml += `<tr><td>${this.translate.instant('settings.document-db.valid-from')}</td><td>${moment(approvalDocumentRes?.version?.validFrom).format('DD.MM.YYYY')}</td></tr>`;
                    }
                    if (approvalDocumentRes?.version?.validTo != null) {
                        modalHtml += `<tr><td>${this.translate.instant('settings.document-db.valid-to')}</td><td>${moment(approvalDocumentRes?.version?.validTo).format('DD.MM.YYYY')}</td></tr>`;
                    }

                    modalHtml += '</table>';

                    let approvalModalRes = await Swal.fire({
                        title: approvalDocumentRes?.info?.name,
                        html: modalHtml,
                        icon: undefined,
                        showCancelButton: true,
                        confirmButtonText: this.translate.instant('shared.open'),
                        cancelButtonText: this.translate.instant('shared.close'),
                        confirmButtonColor: '#2092c9',
                        cancelButtonColor: '#ffc409',
                        customClass: {
                            container: 'approval-m',
                        },
                        heightAuto: false, // for ionic compatibility,
                    });

                    if (!approvalModalRes.isConfirmed) {
                        return;
                    }
                }
            } catch (err) {
                this.logger.error('[UTILS] cannot handle approval document from api', err);
                this.utils.sentryCaptureException(err);
                return;
            }
        }

        // only proceed if url is not null
        if (url != null) {
            let windowReference = !this.utils.isNative ? window.open('about:blank') : undefined;
            try {
                if (windowReference) {
                    windowReference.location.href = this.utils.normalizeUrl(url);
                } else if (this.platform.is('android')) {
                    // for some reason the UX is better on Android when just using window.open....
                    // which weirdly works when native even while being in an async call
                    window.open(this.utils.normalizeUrl(url), '_blank');
                } else {
                    await Browser.open({ url: this.utils.normalizeUrl(url) });
                }
            } catch (err) {
                this.utils.sentryCaptureException(err);
                windowReference?.close();
            }
        }
    }
}
